import createActions from 'utils/redux/createActions'

export default createActions([
	'ATTACHMENTS_LOAD_OK'
  , 'ADD_ATTACHMENT'
  , 'DELETE_ATTACHMENT'
])



// WEBPACK FOOTER //
// ./src/actions/attachmentActions.js